import { RootState } from 'types'

export default function reduce(
  state: RootState['articlePassword'] = {},
  { type, payload }: any,
): RootState['articlePassword'] {
  switch (type) {
    case 'ARTICLE_PASSWORD_SET': {
      return { ...state, [payload.key]: payload.value }
    }
    default:
      return state
  }
}
